const convertCreatedAtOverrideDate = date => {
  // The `createdAtOverride` date is in the format of "YYYY-MM-DD", e.g. "2022-10-18".
  // This needs to be converted into ISO-8601 format for consistency.
  return new Date(date).toISOString();
};

module.exports = {
  convertCreatedAtOverrideDate,
};
